import { render, staticRenderFns } from "./Imports.vue?vue&type=template&id=2d65f108&scoped=true&"
import script from "./Imports.vue?vue&type=script&lang=js&"
export * from "./Imports.vue?vue&type=script&lang=js&"
import style0 from "./Imports.vue?vue&type=style&index=0&id=2d65f108&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d65f108",
  null
  
)

export default component.exports